import { BillingUnitDto } from '@dhl/mdp-api'
import type { BillingUnit } from '~/modules/billingunits/model'
import { convertToAddress } from '~/common/components/addresses'

export const convertToBillingUnit = ({
  name,
  description = '',
  id,
  cccId,
  trackerCodeMin,
  trackerCodeMax,
  trackerCodeLast,
  // address
  street = '',
  number = '',
  addition = '',
  zipCode = '',
  city = '',
  countryCode = '',
}: BillingUnitDto): BillingUnit => ({
  name,
  description,
  id,
  cccId,
  trackerCodeMin,
  trackerCodeMax,
  trackerCodeLast,
  address: convertToAddress({
    street,
    number,
    addition,
    zipCode,
    city,
    countryCode,
    isBusiness: true,
  }),
})
